import React from 'react';
import { ProductProvider } from 'providers';
import Products from './Page';

export default function Page() {
  return (
    <ProductProvider>
      <Products />
    </ProductProvider>
  );
}
